import FileUploadField from "./FileUploadField";
import { gtmPush } from "../../functions/gtm";
import {
  requestTypes,
} from './CVOConstants';

const StepDocs = ({ values, errors, touched, setFieldValue, setFieldTouched, theme }) => {
  //
  const labels = {
    // [requestTypes.NO_LONGER_OWN]: "Transfer of registration (required)",
    [requestTypes.NEW_OWNER]: <><b>Vehicle registration</b> (required)</>,
    [requestTypes.PERSONAL_DETAILS_CHANGED]: <><b>Vehicle registration</b></>,
    [requestTypes.WRITTEN_OFF]: <><b>Insurance confirmation</b> (required)</>,
  };
  const gtmNames = {
    [requestTypes.NEW_OWNER]: "cvoRegistrationDocUpload",
    [requestTypes.PERSONAL_DETAILS_CHANGED]: "cvoRegistrationDocUpload",
    [requestTypes.WRITTEN_OFF]: "cvoInsuranceUpload",
  };

  if (values.requestType === requestTypes.NO_LONGER_OWN) {
    return null;
  }

  return (
    <div>
      <p className="aui-headline-4 mb-4">Supporting documents</p>
      {(values.requestType === requestTypes.NEW_OWNER || values.requestType === requestTypes.WRITTEN_OFF) && (
        <p className="mb-3">
          A clear, legible photo or scan helps us finalise your request smoothly. If we can&apos;t read the details we&apos;ll need to reach out, which may delay the process.
        </p>
      )}
      {values.requestType === requestTypes.PERSONAL_DETAILS_CHANGED && <p className="mb-3">
        For a name or address change, please upload your vehicle registration. If you&apos;ve changed your email or phone number, no supporting document is needed.
      </p>}
      <div>
        <FileUploadField name="files1"
          label={labels[values.requestType]}
          value={values.files1}
          onChange={(v) => {
            setFieldValue('files1', v);
            gtmPush(gtmNames[values.requestType], "ChangeVehicleOwnership");
          }}
          isInvalid={errors.files1 && touched.files1}
          invalidMessage={errors.files1}
          onBlur={() => { setFieldTouched('files1'); }}
          theme={theme}
        />
        {values.requestType === requestTypes.WRITTEN_OFF && <FileUploadField name="files2"
          label={<><b>Personal Property Security Register (PPSR)</b> (optional)</>}
          value={values.files2}
          onChange={(v) => {
            setFieldValue('files2', v);
            gtmPush("cvoPPSRUpload", "ChangeVehicleOwnership");
          }}
          isInvalid={errors.files2 && touched.files2}
          invalidMessage={errors.files2}
          onBlur={() => { setFieldTouched('files2'); }}
        />}
      </div>
      
    </div>
  );
};

export default StepDocs;
